// Libraries
import React from "react"
import { Link, graphql, withPrefix } from "gatsby"
import styles from "@one-builder/gatsby-theme-ob-master/src/styles/global.module.scss"
import { Parallax } from "react-parallax"
import { GoTriangleRight } from "react-icons/go"

// Components (Updated to scoped path)
import Layout from "@one-builder/gatsby-theme-ob-master/src/components/layout/layout"
import MarkdownContent from "@one-builder/gatsby-theme-ob-master/src/components/content"
import TestimonialSlider from "@one-builder/gatsby-theme-ob-master/src/components/home/testimonial-slider"
import NewsletterSignup from "@one-builder/gatsby-theme-ob-master/src/components/home/newsletter-signup"
import { useGetTokens } from "@one-builder/gatsby-theme-ob-master/src/hooks/useGetTokens"
import convertTokens from "@one-builder/gatsby-theme-ob-master/src/helpers/convertTokens"
import setSeoData from "@one-builder/gatsby-theme-ob-master/src/helpers/setSeoData"

import { Fade } from "react-awesome-reveal";

export default ({ data }) => {
  // Get metadata
  const metadata = useGetTokens()

  // Get Home Page Data
  const { home } = data

  let seo_data = setSeoData(home.frontmatter)

  return (
    <Layout seo_data={seo_data}>
      <section id={styles.ctaSection}>
        <div className={styles.container}>
          <h1 className={styles.title}>
            <span>Because</span> You Matter
          </h1>
          <div id={styles.ctaContain}>
            <>
              <Link
                to="/services/remodeling/bathroom-remodeling/"
                style={{
                  backgroundImage: `url(${withPrefix("/images/sub1.jpg")})`,
                }}
              >
                <h2>
                  Bathroom Remodeling <GoTriangleRight />
                </h2>
              </Link>
              <Link
                to="/services/handyman/"
                style={{
                  backgroundImage: `url(${withPrefix("/images/sub2.jpg")})`,
                }}
              >
                <h2>
                  Handyman Services <GoTriangleRight />
                </h2>
              </Link>
              <Link
                to="/services/carpentry/deck-installer/"
                style={{
                  backgroundImage: `url(${withPrefix("/images/sub3.jpg")})`,
                }}
              >
                <h2>
                  Deck Installation <GoTriangleRight />
                </h2>
              </Link>
            </>
            <div className={styles.ctaContent}>
            <Fade direction="down" triggerOnce={true}>
              <MarkdownContent
                content={convertTokens(
                  home.frontmatter.welcomeSection,
                  metadata
                )}
              />
      </Fade>
            </div>
          </div>
        </div>
      </section>

      <section className={`${styles.row} ${styles.row1}`}>
        <div className={styles.container}>
          <div className={styles.flexWrapper}>
            <div id={styles.containLeft}>
              <Fade direction="top-left" triggerOnce={true}>
              <MarkdownContent
                content={convertTokens(home.frontmatter.aboutSection, metadata)}
              />
              <div className={styles.hpBtns}>
                <Link to="/services/carpentry/" title="Carpentry Services">
                  Carpentry Services <GoTriangleRight />
                </Link>
                <Link to="/services/carpentry/window-door-replacement/" title="Windows and Doors">
                  Windows and Doors <GoTriangleRight />
                </Link>
                <Link to="/services/electrical/" title="Electrical Work">
                  Electrical Work <GoTriangleRight />
                </Link>
                <Link to="/services/plumbing-heating-and-air-conditioning/" title="HVAC">
                  HVAC <GoTriangleRight />
                </Link>
              </div>
              </Fade>
            </div>
            <div id={styles.containRight}>
            <Fade direction="bottom-right" triggerOnce={true}>
              <img src="/images/top-right-img.png" alt="Warren Construction" />
              </Fade>
            </div>
          </div>
        </div>
      </section>

      <div
        style={{
          backgroundImage: `url(${withPrefix("/images/divider-1.jpg")})`,
          width: `100%`,
          height: `90px`,
          backgroundPosition: `center`,
          backgroundSize: `cover`,
        }}
      ></div>

      <section className={`${styles.row} ${styles.row2}`}>
        <div className={styles.container}>
          <div className={styles.flexWrapper}>
            <div id={styles.containLeft}>
            <Fade direction="bottom-left" triggerOnce={true}>
              <img src="/images/top-left-img.png" alt="Bathroom Remodeling" />
              </Fade>
            </div>
            <div id={styles.containRight}>
            <Fade direction="top-right" triggerOnce={true}>
              <MarkdownContent
                content={convertTokens(
                  home.frontmatter.contentSection1,
                  metadata
                )}
              />
              <div className={styles.hpBtns} style={{justifyContent: 'flex-start'}}>
                {/* <Link to="/" title="Tile Installation">
                  Tile Installation <GoTriangleRight />
                </Link> */}
                <Link to="/services/plumbing-heating-and-air-conditioning/" title="Plumbing Services">
                  Plumbing Services <GoTriangleRight />
                </Link>
              </div>
              </Fade>
            </div>
          </div>
        </div>
      </section>

      <section
        id={styles.projects}
        className={`${styles.row} ${styles.row3}`}
      >
        <div className={styles.container}>
          <div id={styles.projectContain}>
            <div className={styles.projects}>
            <Fade direction="down" triggerOnce={true}>
              <MarkdownContent
                content={convertTokens(
                  home.frontmatter.contentSection2,
                  metadata
                )}
              />
               <Link to="/services">
              <div className={styles.projectImages}>
                <div><img src="/images/project-1.jpg" alt="Our Work" /></div>
                <div><img src="/images/project-2.jpg" alt="Our Work" /></div>
                <div><img src="/images/project-3.jpg" alt="Our Work" /></div>
                <div><img src="/images/project-4.jpg" alt="Our Work" /></div>
                <div><img src="/images/project-5.jpg" alt="Bathroom Remodeling" /></div>
              </div>
              </Link>
            </Fade>
            </div>
          </div>
        </div>
      </section>

      <section
        id={styles.testimonials}
        className={`${styles.row} ${styles.row4}`}
      >
        <div className={styles.container}>
        <Fade direction="down" triggerOnce={true}>
          <TestimonialSlider />
        </Fade>
        </div>
      </section>

      <div
        style={{
          backgroundImage: `url(${withPrefix("/images/divider-2.jpg")})`,
          width: `100%`,
          height: `90px`,
          backgroundPosition: `center`,
          backgroundSize: `cover`,
        }}
      ></div>

      <section
        id={styles.contest}
        className={`${styles.row} ${styles.row5}`}
      >
        <div className={styles.container}>
        <MarkdownContent
                content={convertTokens(
                  home.frontmatter.contentSection3,
                  metadata
                )}
              />
        <div className={styles.hpBtns} style={{padding: 0, marginTop: -100}}>
            <Link to="/feedback/" title="Feedback">
             Leave a Review! <GoTriangleRight /></Link>
        </div>
        </div>
        
      </section>

      <section id={styles.feeding} 
      className={`${styles.row} ${styles.row6}`}>
        <div className={`${styles.container}`}>
          <div className={styles.flexWrapper}>
            <div className={styles.feedingImg}><Fade direction="left" triggerOnce={true}>
              <a href="https://teamfeed.feedingamerica.org/index.cfm?fuseaction=donorDrive.participant&participantID=3349">
              <img src="/images/feeding.png" alt="Feeding America" /></a></Fade>
            </div>
            <div className={styles.feedingContent}>
              <Fade direction="right" triggerOnce={true}>
                <MarkdownContent
                  content={convertTokens(
                    home.frontmatter.contentSection4,
                    metadata
                  )}
                />
              </Fade>
            </div>
          </div>
          <div className={styles.hpBtns}>
            <Link to="https://teamfeed.feedingamerica.org/index.cfm?fuseaction=donorDrive.participant&participantID=3349" title="Feeding America">
                Donate to Feeding America <GoTriangleRight /></Link>
          </div>
        </div>
      </section>

      <section className={`${styles.row} ${styles.row7}`}>
        <div className={`${styles.container}`}>
          <div>
            <MarkdownContent
              content={convertTokens(
                home.frontmatter.contentSection5,
                metadata
              )}
            />
          </div>
        </div>
      </section>

      {/* <section id={styles.newsletterSignup}>
        <div className={`${styles.container} ${styles.flexWrapper}`}>
          <div className={styles.newsletterContent}>
            <h2>Stay in touch</h2>
            <p>Subscribe to receive our latest news and offers.</p>
          </div>
          <NewsletterSignup />
        </div>
      </section> */}
    </Layout>
  )
}
export const query = graphql`
  query {
    home: markdownRemark(frontmatter: { title: { eq: "Home" } }) {
      id
      frontmatter {
        title
        is_active
        meta {
          title
          description
          page_visible
        }
        template
        ctaSection
        welcomeSection
        aboutSection
        contentSection1
        contentSection2
        contentSection3
        contentSection4
        contentSection5
        testimonials {
          name
          review
        }
      }
    }
  }
`
